import { render, staticRenderFns } from "./RoundsEdit.vue?vue&type=template&id=7c1b0850&"
import script from "./RoundsEdit.vue?vue&type=script&lang=js&"
export * from "./RoundsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports